import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAaNotice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={16}
    fill="currentColor"
    viewBox="0 0 12 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.494 16q-.62 0-1.056-.44A1.45 1.45 0 0 1 0 14.5V4.625q0-.296.104-.565t.334-.497L3.563.438A1.44 1.44 0 0 1 4.625 0H10.5q.619 0 1.06.44.44.442.44 1.06v13q0 .619-.44 1.06-.442.44-1.06.44zm.006-1.5h9v-13H4.625L1.5 4.625zM5.996 12q.316 0 .535-.214a.71.71 0 0 0 .219-.532.74.74 0 0 0-.214-.535.71.71 0 0 0-.532-.219.74.74 0 0 0-.535.214.71.71 0 0 0-.219.532q0 .316.214.535t.532.219m0-3q.316 0 .535-.216a.72.72 0 0 0 .219-.534v-2.5a.73.73 0 0 0-.214-.534A.72.72 0 0 0 6.004 5a.73.73 0 0 0-.535.216.72.72 0 0 0-.219.534v2.5q0 .319.214.534A.72.72 0 0 0 5.996 9"
    />
  </svg>
);
export default SvgAaNotice;
